import React from 'react'
import PropTypes from 'prop-types';
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { Breadcrumb } from 'react-bootstrap'

import style from './breadcrumbs.css';

export default class BreadcrumbSection extends React.Component {
  static propTypes = {
    breadcrumbs : PropTypes.array
  }

  render() {
    const { history, children, breadcrumbs : crumbs } = this.props
    let breadcrumbs
    let arr = []
    const pn = history.location.pathname
    // Super hack. I dont like the breadcrumbs to shift the ui...and authz 
    // doesn't have any..
    if ( pn.indexOf( '/authz' ) < 0 && pn.split( '/' ).length >= 5 ) {
      arr.push( null )
    }
    // I don't want breadcrumbs for OIDC screen. Steve did first ^_^
    if ( pn.includes( 'oidc' ) && pn.split( '/' ).length >= 5 ) {
      arr = []
    }

    if ( crumbs && crumbs.length > 1 ) {
      crumbs.forEach( ( item, index ) => {

        arr.push( 
          item.link == null ? 
            <Breadcrumb.Item key={item.name} active>{item.name}</Breadcrumb.Item> : 
            <li key={item.link}><Link to={item.link}>{item.name}</Link></li> 
        )

      } )
      breadcrumbs = <Breadcrumb className={style.breadcrumbs}>{arr}</Breadcrumb>
    } else {
      breadcrumbs = <Breadcrumb className={style.breadcrumbs}/> // </Breadcrumb>null /* <div></div>*/
    }
    const clazz = classNames( style.breadcrumbSection, arr.length === 0 && style.collapse, this.props.className );
    return (
      <div className={clazz}>
        {breadcrumbs}
        <div className={style.content}>
          {children}
        </div>
      </div>
    )
  }
}
